import React, { Dispatch, SetStateAction, startTransition, useContext, useEffect, useMemo, useRef, useState } from "react";
import "./FilterBar.css"

import { TfiClose } from "react-icons/tfi";
import { Filter } from "../../../../components/filter/filter";
import { AppContext } from "../../../../context/AppContext";
import { GoSearch } from "react-icons/go";
import { FilterItem,listFilters,allShowFilter, getPageContextAnalytics, trackGaFilterEventOncePerSession, formatFilterLabel, getCuisineDisplayLabel, FilterValue, TIME_FILTERS, getVisibleFilters } from "../../../../components/types/types";
import { useLocation, useNavigate } from "react-router-dom";
import MaskBackground from "../../../../components/maskBackground/maskBackground";
import { RestaurantContext } from "../../../../context/RestaurantContext";
import { countMiniRestoResults,CurrentCity,getAllPresentFilterFromMiniRestos, getContextualMiniRestos, getInitialCurrentCity, getLockedFilterValues, useSeoSearchAnchor } from "../../SearchPage/hookSearchPage";
import { useClickOutside } from "../../../../components/hook/clickOutside";
import { getOpeningServiceFromFilters, isMiniRestoStillValidForService } from "./hookFilterBar";
import { FiInfo } from "react-icons/fi";
import { buildSearchQuery } from "../../hookHomeScreen/useSearchQuerySync";
import { isNoteFilter } from "../../../../utils/utilsNotes";
import { isPriceFilter } from "../../../../utils/utilsPrice";
import { trackZeroResultSearchClick } from "../../../../components/analytics/hookAnalytics";
const filters: FilterItem[] = listFilters

const isSameFilter = (a: FilterValue, b: FilterValue): boolean => {
  if (Array.isArray(a) && Array.isArray(b)) {
    return a[0] === b[0] && a[1] === b[1];
  }

  return a === b;
};
export const getDraftDateHour = (currentFilter:FilterValue[],filterChoose:FilterValue[], date_selected:Date|null,hour_selected:string) => {
    const selectedTimeFilter = currentFilter.find(
        (filter): filter is string =>
        typeof filter === "string" && TIME_FILTERS.has(filter)
    );

    if (!selectedTimeFilter) {
        const previouslyHadTimeFilter = filterChoose.some(
        (filter) => typeof filter === "string" && TIME_FILTERS.has(filter)
        );
        if (previouslyHadTimeFilter) return {date: null,hour: "",};

        return {date: date_selected,hour: hour_selected };
    }
    const now = new Date();
    if (selectedTimeFilter === "Ouvert ce midi") return {date: now,hour: "12h30",};
    if (selectedTimeFilter === "Ouvert ce soir") return {date: now,hour: "20h00",};


    if (selectedTimeFilter === "Ouvert demain midi") {const tomorrow = new Date(now);
        tomorrow.setDate(now.getDate() + 1);
        return {date: tomorrow,hour: "12h30"};
    }
    if (selectedTimeFilter === "Ouvert demain soir") {
        const tomorrow = new Date(now);
        tomorrow.setDate(now.getDate() + 1);
        return {date: tomorrow,hour: "20h00",};
    }
    const hour = `${String(now.getHours()).padStart(2, "0")}h${String(now.getMinutes()).padStart(2, "0")}`;
    return { date: now,hour,};
};

interface FilterBarProps {
    showAll:number,
    setShowAll: Dispatch<SetStateAction<number>>,

    routeCity: string;
    currentFilter:FilterValue[],
    setCurrentFilter: Dispatch<SetStateAction<FilterValue[]>>,
    isForHome?:boolean,

    contextualRestos?: any[];
}
const FilterBar:React.FC<FilterBarProps> = ({showAll,setShowAll, routeCity,currentFilter,setCurrentFilter,isForHome=false,contextualRestos: contextualRestosFromParent}) => {
  const {showFilterTel,indexablePages,setShowFilterTel,filterChoose,date_selected,hour_selected,coordonates,setFilterChoose,searchFilterValue,setSearchFilterValue,setDate_selected,setHour_selected,setValueSearchCity,setSearchCity,setCoordonates,currentNeighborhood} = useContext(AppContext)
  const {priceFilter,fetchRestaurants,miniRestosLoaded,miniRestos,fetchMiniRestos} = useContext(RestaurantContext)
  const [isMobile, setIsMobile] = useState(false);
  const [hasFilterScrollTop, setHasFilterScrollTop] = useState(false);

  const [showCantSearch,setShowCantSearch] = useState(false)

  const [showCantFilter,setShowCantFilter] = useState(false)
useEffect(() => {
    if (!showCantFilter) return;
    const timeout = setTimeout(() => {
        setShowCantFilter(false);
    }, 3500);
    return () => clearTimeout(timeout);
}, [showCantFilter]);

  const visibleCurrentFilters = useMemo(() => {
    return getVisibleFilters(currentFilter);
}, [currentFilter]);

  useEffect(() => {
        if (!showFilterTel) return;
        setCurrentFilter([...filterChoose]);
        setSearchFilterValue("");
    }, [showFilterTel]);
    const currentCity = useMemo<CurrentCity | null>(() => {
        return getInitialCurrentCity(routeCity, indexablePages);
    }, [routeCity, indexablePages]);
    
    const draftDateHour = useMemo(() => getDraftDateHour(currentFilter,filterChoose,date_selected,hour_selected),
        [currentFilter,filterChoose,date_selected,hour_selected]);


    const contextualDistance = currentCity?.slug === "restaurants-a-proximite" ? 5 : null;
    const contextualRestos = useMemo(() => {
        if (contextualRestosFromParent) return contextualRestosFromParent;
        if (!miniRestosLoaded) return [];
        const contextualResults =  getContextualMiniRestos( miniRestos, currentCity, draftDateHour.date, draftDateHour.hour, coordonates,contextualDistance,currentNeighborhood);
        const openingService = getOpeningServiceFromFilters(currentFilter);
        if (!openingService) return contextualResults;
        return contextualResults.filter((restaurant) => {
            return isMiniRestoStillValidForService(restaurant,openingService);
        });

    }, [contextualRestosFromParent,currentFilter,miniRestosLoaded,miniRestos,currentCity,draftDateHour.date,draftDateHour.hour,coordonates,contextualDistance]);
const hasContextualData = contextualRestosFromParent !== undefined || miniRestosLoaded;
  const barRef = useRef<HTMLDivElement>(null)
  useClickOutside(barRef, showFilterTel, () => {
    if(showAll === 0) discardAndClose();
  })

  
    const searchInputRef = useRef<HTMLInputElement>(null);
    const handleFilterScroll = (e: React.UIEvent<HTMLDivElement>) => {
        const next = e.currentTarget.scrollTop > 2;
        setHasFilterScrollTop(prev => prev === next ? prev : next);
    };
    useEffect(() => {
        const isCoarse = window.matchMedia("(pointer: coarse)").matches;
        if (!isCoarse) return;
        const handlePointerDown = (e: PointerEvent) => {
            const input = searchInputRef.current;
            if (!input) return;
            if (document.activeElement !== input) return;
            if (e.target instanceof Node && input.contains(e.target)) return;
            input.blur();
        };
        document.addEventListener("pointerdown", handlePointerDown, {
            passive: true,
        });

        return () => {
            document.removeEventListener("pointerdown", handlePointerDown);
        };
    }, []);

    const previousFilterChooseRef = useRef<FilterValue[] | null>(null);
    useEffect(() => {
        const currentFilters = getVisibleFilters(filterChoose);
        if(previousFilterChooseRef.current === null){
            previousFilterChooseRef.current = currentFilters;
            return;
        }
        const previousFilters = previousFilterChooseRef.current;

        if (currentFilters.length > previousFilters.length) {
            const addedFilters=currentFilters.filter((filter)=>!previousFilters.some((previous)=>isSameFilter(previous,filter)));
            const pageContext = getPageContextAnalytics();
            addedFilters.forEach((addedFilter, index) => {
                const filterName = formatFilterLabel(addedFilter);
                const lengthAtAddition = previousFilters.length + index + 1;
                if (lengthAtAddition === 1) {
                    trackGaFilterEventOncePerSession({
                        bucket: "first",
                        eventName: "qr_first_filter_selected",
                        filterName: filterName,
                        pageContext,
                        params: {
                            filter_name: filterName,
                            page_context: pageContext
                        }
                    });
                    return;
                }
                if (lengthAtAddition === 2) {
                    trackGaFilterEventOncePerSession({
                        bucket: "second",
                        eventName: "qr_scnd_filter_selected",
                        filterName: filterName,
                        params: {
                            filter_name: filterName
                        }
                    });
                    return;
                }
                trackGaFilterEventOncePerSession({
                    bucket: "thirdplus",
                    eventName: "qr_thirdplus_filter_selected",
                    filterName: filterName,
                    params: {
                        filter_name: filterName
                    }
                });
            });
        }
        previousFilterChooseRef.current = currentFilters;
    }, [filterChoose]);
    useEffect(() => {
        const checkScreenSize = () => {
        setIsMobile(window.innerWidth < 699 && showFilterTel);
        };

        checkScreenSize();
        window.addEventListener("resize", checkScreenSize);

        return () => window.removeEventListener("resize", checkScreenSize);
    }, [showFilterTel]);
    const navigate = useNavigate()

    const shouldLoadMiniRestos =  showFilterTel && !miniRestosLoaded;

    useEffect(() => {
        if (!shouldLoadMiniRestos) return;
        fetchMiniRestos();
    }, [shouldLoadMiniRestos, fetchMiniRestos]);

    const presentFilters = useMemo(() => {
        if (!hasContextualData || contextualRestos.length === 0)  return getAllPresentFilterFromMiniRestos(miniRestos);
        return getAllPresentFilterFromMiniRestos(contextualRestos);
    }, [hasContextualData, contextualRestos, miniRestos]);

    const filterResultCount = useMemo(() => {
        if (!hasContextualData) return null;
        return countMiniRestoResults(contextualRestos,currentFilter,presentFilters);
    }, [hasContextualData,contextualRestos,currentFilter,presentFilters]);
    const previousSliderStateRef = useRef<{price?: [number, number];note?: string;resultCount: number;} | null>(null);
    useEffect(() => {
        if (!showFilterTel && !isForHome) {
            previousSliderStateRef.current = null;
            return;
        }
        if (filterResultCount === null) return;
        const currentPrice = currentFilter.find(isPriceFilter);
        const currentNote = currentFilter.find(isNoteFilter);
        const previous = previousSliderStateRef.current;
        if (!previous) {
            previousSliderStateRef.current = {
                price: currentPrice,
                note: currentNote,
                resultCount: filterResultCount
            };
            return;
        }
        const priceChanged = previous.price?.[0] !== currentPrice?.[0] || previous.price?.[1] !== currentPrice?.[1];
        const noteChanged = previous.note !== currentNote;
        const becameZero = previous.resultCount > 0 && filterResultCount === 0;
        if ( becameZero && (priceChanged || noteChanged)) setShowCantFilter(true);
        previousSliderStateRef.current = {
            price: currentPrice,
            note: currentNote,
            resultCount: filterResultCount
        };
    }, [showFilterTel,currentFilter,filterResultCount,isForHome]);


    const currentListFilter = useMemo(() => {
        const filterSet = new Set(presentFilters.filters);
        return filters.map((elem) => {
            if (["Prix par personne", "Notes"].includes(elem.value)) return elem;
            if (elem.value === "Type de restaurant") return { ...elem, liste: presentFilters.types };
            if (elem.value === "Origine de la cuisine") return { ...elem, liste: presentFilters.cuisines };

            return { ...elem, liste: elem.liste?.filter((x) => filterSet.has(x)) ?? [] };
        });

    }, [presentFilters]);


    const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchFilterValue(event.target.value)      
    }

    const displayedFilters = useMemo(() => {
        return (currentListFilter || []).filter((f) => {
            return (f.liste?.length || allShowFilter.includes(f.value));
        });
    }, [currentListFilter]);
    const candidateFilterValues = useMemo(() => {
        const values: string[] = [];
        for (const filter of displayedFilters) {
            if (filter.value === "Prix par personne" || filter.value === "Notes" ) continue;
            for (const value of filter.liste ?? []) {
                if (typeof value === "string") {
                    values.push(value);
                }
            }
        }
        return values;
    }, [displayedFilters]);
    const lockedFilterValues = useMemo(() => {
        if (!hasContextualData) return new Set<string>();
        return getLockedFilterValues(contextualRestos,currentFilter,presentFilters,candidateFilterValues
        );
    }, [hasContextualData,contextualRestos,currentFilter,presentFilters,candidateFilterValues]);

    const location = useLocation();
   const handleCurrentFilterRemove = (value: FilterValue) => {
        setCurrentFilter((previous) =>
            previous.filter(
            (filter) => !isSameFilter(filter, value)
            )
        );
    };

    const clickAllDelete = () => {
        setCurrentFilter(prev =>
            prev.filter(
                filter => typeof filter === "string" && TIME_FILTERS.has(filter)
            )
        );
    }
    const discardAndClose = () => {
        setCurrentFilter([...filterChoose]);
        setSearchFilterValue("");
        setShowFilterTel(false);
    };
    const { shouldKeepCurrentSeoPath } = useSeoSearchAnchor({pathname: location.pathname,indexablePages,currentFilter,currentCitySlug: currentCity?.slug ?? null,});
    const applyCurrentFilters = () => {
        if(filterResultCount === 0) {
            setShowCantSearch(true)
            setTimeout(() => {
                setShowCantSearch(false)
            },5000)
            trackZeroResultSearchClick({
                searchSurface:"filter_bar_mobile",
                filterCount:visibleCurrentFilters.length
            });
            return;
        }

        const hasNoFiltersLeft = currentFilter.length === 0;
        const hasNoDateFilter = !draftDateHour.date && !draftDateHour.hour;

        const oldPrice = filterChoose.find((filter): filter is [number, number] =>Array.isArray(filter));
        const nextPrice = currentFilter.find((filter): filter is [number, number] =>Array.isArray(filter));

        const selectedTimeFilter = currentFilter.find((filter): filter is string =>typeof filter === "string" && TIME_FILTERS.has(filter));
        if (selectedTimeFilter) {
            setDate_selected(draftDateHour.date);
            setHour_selected(draftDateHour.hour);
        } else {
            const previouslyHadTimeFilter = filterChoose.some(
                (filter) => typeof filter === "string" && TIME_FILTERS.has(filter)
            );
            if (previouslyHadTimeFilter) {
                setDate_selected(null);
                setHour_selected("");
            }
        }

        const previouslyHadProximity = filterChoose.includes("À proximité");
        const nowHasProximity = currentFilter.includes("À proximité");

        if (previouslyHadProximity && !nowHasProximity) {
            setValueSearchCity("");
            setCoordonates({latitude: "",longitude: "",});
            setSearchCity("");
        }

        
        setFilterChoose(currentFilter);
        const nextSearch = buildSearchQuery({filterChoose: currentFilter,dateSelected: draftDateHour.date,hourSelected: draftDateHour.hour,currentNeighborhood,});
        if (!location.pathname.startsWith("/map")) {

            if (shouldKeepCurrentSeoPath) {
            } else if (currentCity?.slug) {
                navigate({pathname: `/${currentCity.slug}`,search: nextSearch}, {
                    state: { topBarMode: "search" }
                });
            } else if (currentFilter.length > 0 || draftDateHour.date || draftDateHour.hour) {
                navigate({pathname: '/',search: nextSearch}, {
                    state: { topBarMode: "search" }
                });
            } else {
                navigate("/restaurants", {
                    state: { topBarMode: "search" }
                });
            }
        }

        if (nextPrice && (!oldPrice ||oldPrice[0] !== nextPrice[0] ||oldPrice[1] !== nextPrice[1])) priceFilter(nextPrice[0], nextPrice[1]);
        if ( JSON.stringify(oldPrice) !== JSON.stringify(nextPrice)) fetchRestaurants?.();
  
        setSearchFilterValue("");
        setShowFilterTel(false);
    };
    const typeResultCounts = useMemo(() => {
        const counts = new Map<string, number>();
        for (const resto of contextualRestos) {
            const types = resto.type ?? [];
            for (const type of types) {
                counts.set(type,(counts.get(type) ?? 0) + 1);
            }
        }

        return counts;
    }, [contextualRestos]);

    
    const [isResultCountLoading, setIsResultCountLoading] = useState(false);
    useEffect(() => {
        setIsResultCountLoading(true);
        const timeout = window.setTimeout(() => {
            setIsResultCountLoading(false);
        }, 500);
        return () => {
            window.clearTimeout(timeout);
        };
    }, [currentFilter]);
    const isFilterDataLoading = !hasContextualData || filterResultCount === null;
    return (
        <>
       <div
            className={`containerFilterBar primaryBack ${!showFilterTel && 'notShowTel'} ${isForHome ? 'isForHome' : ''}`}
            id="containerFilterBar"
            ref={barRef}
        >
            {showCantFilter && !showCantSearch && <div className="containerCantSearchFilter smallText">
                <FiInfo className='icon' />
                <span>Aucun résultat trouvé. Essayez d'enlever un ou plusieurs filtres.</span>
            </div>}
            <div className={`shadowTop ${hasFilterScrollTop ? "isActive" : ""}`}></div>
            <div className="shadowBottom"></div>
            {isMobile && <div className="maskForPhone"><MaskBackground /></div> }
            <div className='filterBar' >
                <div className="closeFilterOnglet" >
                    <p className="largeTitle">Filtres</p>
                    <TfiClose size={18} className="pointer lowOpacityHover" style={{marginRight:'5%'}} onClick={() => {
                        discardAndClose();
                    }}/>
                </div>
                <div className={`mainCorp ${visibleCurrentFilters.length > 0 && "hasSelectFilter"}`} onScroll={handleFilterScroll}>
                    <div className={`containerInputFilter ${searchFilterValue ? 'isSearch' : ''}`}>      
                            <GoSearch className="searchIcon" color="black" size={18} />
                            <input ref={searchInputRef} type="search" className="inputFilter XsmallText" placeholder="Rechercher un filtre..." value={searchFilterValue} onChange={handleSearch} style={{backgroundColor:"transparent"}} maxLength={50} />
                            
                            {searchFilterValue &&  <div className="containerReset flexAllCenter" onClick={() => setSearchFilterValue("")}><TfiClose className="resetIcon lowOpacityHover"  size={17} /></div> }
                    </div>
                    <div className={`listeFilter ${searchFilterValue ? 'isCurrentSearch' : ''}`} >
                        {!searchFilterValue && visibleCurrentFilters.length > 0 && <>
                            <div className="forComputer">
                                <Filter setShowCantFilter={setShowCantFilter} value={`Mes filtres (${visibleCurrentFilters.length})`} liste={visibleCurrentFilters as string[]}  setShowAll={setShowAll} searchValue={searchFilterValue} listFilter={currentFilter} setListFilter={setCurrentFilter} />
                            </div>
                            <div className="separationFilter forComputer"></div>
                        </>}          
                        {displayedFilters && displayedFilters.map((filter, index) => (
                            <React.Fragment key={index}>
                                <Filter
                                    setShowCantFilter={setShowCantFilter}
                                    value={filter.value}
                                    liste={filter.liste || [] }
                                    setShowAll={setShowAll}
                                    searchValue={searchFilterValue}
                                    listFilter={currentFilter}
                                    setListFilter={setCurrentFilter}
                                    lockedFilterValues={lockedFilterValues}
                                    filterResultCounts={filter.value === "Type de restaurant" ? typeResultCounts : undefined}
                                />
                                {index < displayedFilters.length -1 && !searchFilterValue && <div className="separationFilter"></div>}
                            </React.Fragment>
                        ))}      
                    </div>
      
                </div>
                <div className="footerPart XsmallText primaryBack">
                    <div className="shadowComputer"></div>
                    {visibleCurrentFilters.length > 0 && <><div className="listeFilterChoose">
                        <div className="shadowLeftFilterChoose"></div>
                        <div className="shadowRightFilterChoose"></div>
                        <div className="listFilterScroll">
                        {visibleCurrentFilters.map((elem,id) => {
                            let displayValue:string= formatFilterLabel(elem);
                            return <span className="pointer lowOpacityHover" onClick={() => handleCurrentFilterRemove(elem)} key={'elemChoose'+id}>{getCuisineDisplayLabel(displayValue)} <TfiClose className="iconClose" size={11}/></span>})}
                        </div>
                    </div>
                    <div className="separationFooter"></div>
                    </>}
                    <div className="buttonPart">
                        <span className="midWhiteRoundButton" onClick={clickAllDelete}>Tout effacer</span>
                        <span className={`midGoldRoundButton ${filterResultCount === 0 ? 'isLock' : ''}`} onClick={() => {
                        applyCurrentFilters()}}>
                            
                            {isResultCountLoading ? <span className="countSpinnerLoad" /> : 
                            isFilterDataLoading ? (
                                    <> Afficher <span className="countSpinnerLoad" /> </>
                                ) : (
                                    <> Afficher <i>{`(${filterResultCount} résultat${(filterResultCount??0)>1 ? 's' :''})`}</i> </>
                                )}
                        </span>
                        {showCantSearch && <div className="containerCantSearch smallText">
                                <FiInfo className='icon' />
                                <span>Aucun résultat trouvé. Essayez d'enlever un ou plusieurs filtres.</span>
                            </div>}
                    </div>
                </div>
            </div> 
                           
        </div>
        </>
    )
}

export default FilterBar